
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/marketplace/yclients",
      function () {
        return require("private-next-pages/[locale]/marketplace/yclients.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/marketplace/yclients"])
      });
    }
  